var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import styled, { css, keyframes } from "styled-components";
import colors from "../../designSystem/colors";
var lightningEffect = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n  }\n\n  80% {\n    opacity: 0;\n  }\n\n  90% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n\n  80% {\n    opacity: 0;\n  }\n\n  90% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])));
var LightningBar = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n"], ["\n  position: absolute;\n  ", "\n"])), function (props) { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", "px;\n    width: ", "px;\n    background: ", ";\n    animation: ", "s ", " linear infinite;\n    ", "\n    ", "\n    ", "\n    ", "\n  "], ["\n    height: ", "px;\n    width: ", "px;\n    background: ", ";\n    animation: ", "s ", " linear infinite;\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), props.height, props.width, props.fill, props.duration, lightningEffect, props.top ? "top: " + props.top + "px;" : "", props.left ? "left: " + props.left + "px;" : "", props.right ? "right: " + props.right + "px;" : "", props.bottom ? "bottom: " + props.bottom + "px;" : ""); });
var Lightning = function (_a) {
    var _b = _a.themeColor, themeColor = _b === void 0 ? colors.products.yield : _b, props = __rest(_a, ["themeColor"]);
    var color = useMemo(function () {
        return Math.random() <= 0.6 ? themeColor : "white";
    }, [themeColor]);
    var duration = useMemo(function () {
        return Math.random() * 3 + 1;
    }, []);
    return _jsx(LightningBar, __assign({}, props, { fill: color, duration: duration }), void 0);
};
export default Lightning;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Lightning.js.map